/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { UsageUnit } from '../models/UsageUnit';

/**
* Raw usage amount and unit that generated the associated cost.
*/
export class Usage {
  /**
  * Raw usage quantity that generated the cost. 
  */
  'amount': number;
  'unit': UsageUnit;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "amount",
      "baseName": "amount",
      "type": "number",
      "format": "double"
    },
    {
      "name": "unit",
      "baseName": "unit",
      "type": "UsageUnit",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Usage.attributeTypeMap;
  }

  public constructor() {
  }
}



